import projectCalendarComponent from './project-calendar.component';

const projectCalendarModule = angular.module('projectCalendar', [
])
  .component('projectCalendar', projectCalendarComponent)
  .name;

export default projectCalendarModule;
